import { PageMetaData } from '@/components';
import { TopBar, TopNavBar, Footer } from '@/layout';
import { Container, Row, Col, Card } from 'react-bootstrap';
import { Link } from '@/compat/react-router-dom';
import { getPartnerInquiryPath, getPartnerLoginPath } from '@/utils/partnerRoutes';

const PartnerProgram = () => {
  return (
    <>
      <PageMetaData
        title="Partner Program"
        description="Partner with South Crete Tours. Join our partner network and offer premium travel experiences to your customers."
        keywords="travel partner program, travel agency partnerships, Crete partner network"
      />
      <TopBar />
      <TopNavBar />
      <main className="py-5 py-lg-6">
        <Container>
          <h1 className="sec-title mb-3 text-center">Partner Program</h1>
          <Row className="g-4 mt-4">
            <Col md={6}>
              <Card>
                <Card.Body className="p-4">
                  <h3>For Partners</h3>
                  <p>
                    Join our partner network and access exclusive rates, real-time availability,
                    and dedicated support for your travel business.
                  </p>
                  <Link to={getPartnerLoginPath()} className="btn btn-primary">
                    Partner Login
                  </Link>
                </Card.Body>
              </Card>
            </Col>
            <Col md={6}>
              <Card>
                <Card.Body className="p-4">
                  <h3>Become a Partner</h3>
                  <p>
                    South Crete creates partner accounts manually. Send an inquiry and we will
                    prepare your portal — there is no self-serve signup.
                  </p>
                  <Link to={getPartnerInquiryPath()} className="btn btn-outline-primary">
                    Request access
                  </Link>
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </main>
      <Footer />
    </>
  );
};

export default PartnerProgram;
